'use client'

import { Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { useIsOgApp } from '@/utils/og'

export default function CoinsTableTitleClient() {
  const coinTableT = useTranslations('coinTable')
  const isOgApp = useIsOgApp()

  if (isOgApp) return null

  return (
    <Text component="h2" variant="heading1" c="#fff">
      {coinTableT('title')}
    </Text>
  )
}
